// app.routes.ts

import { Routes } from '@angular/router';
import { ShopDetailComponent } from './shop-detail/shop-detail.component';
import { CategoryDetailComponent } from './category-detail/category-detail.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ItemComponent } from './item/item.component';
import { LoginComponent } from './login/login.component';
import { IdeaComponent } from './idea/idea.component';
import { GpsComponent } from './gps/gps.component';
import { ProfileComponent } from './profile/profile.component';
import { RegisterComponent } from './register/register.component';
import { FamilyComponent } from './family/family.component';
import { authGuard } from './auth.guard';


export const APP_ROUTES: Routes = [
 

    // // Option 1: Lazy Loading another Routing Config
    // {
    //     path: 'flight-booking',
    //     loadChildren: () =>
    //         import('./booking/flight-booking.routes')
    //             .then(m => m.FLIGHT_BOOKING_ROUTES)
    // },
  { path: 'list', canActivate: [authGuard], loadComponent: () => 
    import('./list/list.component')
        .then(m => m.ListComponent)
  },
    { path: 'profile/shop', canActivate: [authGuard], loadComponent: () =>
    import('./profile/shop/shop.component')
        .then(m => m.ShopComponent)
  },
  { path: 'profile/gegevens', canActivate: [authGuard], loadComponent: () =>
    import('./profile/gegevens/gegevens.component')
        .then(m => m.GegevensComponent)
  },
  { path: 'profile/instellingen', canActivate: [authGuard], loadComponent: () =>
    import('./profile/instellingen/instellingen.component')
        .then(m => m.InstellingenComponent)
  },
  { path: 'profile/winkel-indeling', canActivate: [authGuard], loadComponent: () =>
    import('./profile/winkel-indeling/winkel-indeling.component')
        .then(m => m.WinkelIndelingComponent)
  },
  { path: 'profile/mijn-lijsten', canActivate: [authGuard], loadComponent: () =>
    import('./profile/mijn-lijsten/mijn-lijsten.component')
        .then(m => m.MijnLijstenComponent)
  },
  { path: 'shop-detail/:shopId', component: ShopDetailComponent , canActivate: [authGuard]},
  { path: 'category-detail/:categoryId', component: CategoryDetailComponent, canActivate: [authGuard] },
  { path: 'product-detail/:productId', component: ProductDetailComponent, canActivate: [authGuard] },
  { path: 'item', component: ItemComponent, canActivate: [authGuard] },
  { path: 'family', component: FamilyComponent },
  { path: 'login', component: LoginComponent },
  { path: 'idea', component: IdeaComponent, canActivate: [authGuard]},
  { path: 'gps', component: GpsComponent , canActivate: [authGuard]},
  { path: 'profile', component: ProfileComponent, canActivate: [authGuard] },
  { path: 'register', component: RegisterComponent },
 
    // Option 2: Directly Lazy Loading a Standalone Component
    {
        path: 'next-flight',
        loadComponent: () => 
            import('./listnew/listnew.component')
                .then(m => m.ListnewComponent)
    },
    { path: '', redirectTo: 'family', pathMatch: 'full' },
    { path: '**', redirectTo: 'family', pathMatch: 'full' },
];